<template>
  <v-app-bar class="px-lg-16 px-lg-16 suraasa-app-bar" color="white">
    <router-link :to="{ name: 'Home' }">
      <v-img
        alt="suraasa"
        contain
        :src="require(`@/assets/logo/suraasa-logo.svg`)"
        width="55"
      />
    </router-link>

    <v-spacer />

    <div class="suraasa-height-100">
      <v-tabs v-model="tab" color="primary">
        <v-tab
          active-class="primary--text"
          exact
          :to="{ name: 'ListChallengedEvaluations' }"
        >
          Challenged Evaluations
        </v-tab>
        <v-tab
          active-class="primary--text"
          exact
          :to="{ name: 'ListEvaluations' }"
        >
          Evaluations
        </v-tab>
      </v-tabs>
    </div>

    <notifications />

    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <div class="d-flex align-center" v-on="on">
          <div>
            <v-badge
              bordered
              bottom
              color="green"
              dot
              offset-x="20"
              offset-y="10"
            >
              <v-avatar class="mx-3" size="32">
                <v-icon x-large>mdi-account-circle</v-icon>
              </v-avatar>
            </v-badge>
          </div>
          <div class="d-flex flex-column profile-name">
            <p class="body-2 lightCarbon--text hidden-sm-and-down">
              {{ fullName }}
            </p>
            <p class="subtitle-2 hidden-sm-and-down">
              {{ USER_TYPE }}
            </p>
          </div>
        </div>
      </template>
      <v-list>
        <v-list-item class="hidden-md-and-up">
          <v-list-item-subtitle>
            {{ fullName }}
          </v-list-item-subtitle>
        </v-list-item>
        <v-list-item @click="logout">
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { getAuthInfo } from '@/utils/helpers'
import { USER_TYPE } from '@/utils/constants'
import authMixin from '@/utils/mixins/auth'

// Components
import Notifications from '@/components/_shared/Notifications.vue'

export default {
  name: 'TheAppBar',

  components: {
    Notifications,
  },

  mixins: [authMixin],

  data: () => ({
    tab: 0,
  }),

  computed: {
    fullName() {
      const authInfo = getAuthInfo()
      return `${authInfo.user.first_name} ${authInfo.user.last_name}`
    },
    USER_TYPE: () => USER_TYPE,
  },
}
</script>

<style lang="scss">
.profile-name {
  cursor: pointer;
  &:hover {
    color: var(--v-primary-base) !important;
  }
}

// Remove default padding of v-app-bar
.suraasa-app-bar {
  .v-toolbar__content {
    padding-bottom: 0;
    padding-top: 0;
  }
}

.suraasa-height-100,
.suraasa-height-100 > div,
.suraasa-height-100 > div > div {
  height: 100%;
}
</style>
